import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const StyledNavLink = styled(NavLink)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;